export const colors = {
  GREY: '#404040',
  // BLUE: '#505870',
  // BLUE: '#6980ad',
  BLUE: '#546aa7',
  LIGHTBLUE: '#c0c8df',
  // BLUE: '#115ab2',
  LIGHTGREY: '#f7f5f4'
}